
import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { Result } from '../models/common/resultResponse';
import { IUserPreferencesApi } from './base';
import { UserPreferencesSaveRequest } from '../models/request/userPreferencesRequest';
import { UserPreferencesSaveResponse } from '../models/response/userPreferencesResponse';

const baseRoute: string = 'UserPreferences';

export class UserPreferencesApi extends IUserPreferencesApi {
  getUserPreferences(): Promise<AxiosResponse<Result<UserPreferencesSaveResponse[]>>> {
    return api.get(`${baseRoute}`);
  };
  
  saveUserPreferences(
    request: UserPreferencesSaveRequest
  ): Promise<AxiosResponse<Result<UserPreferencesSaveResponse>>> {
    return api.post(`${baseRoute}`, request)
  }
}
